<h3 mat-dialog-title>
    Don't change this — tell Gable why
    <button mat-icon-button [disableRipple]="true" mat-dialog-close type="button" aria-label="Close">
        <i class="ph-bold ph-x icon-muted icon-20" aria-hidden="true"></i>
    </button>
</h3>

<mat-dialog-content>
    <p class="reason-lead">
        A quick reason helps Gable make better suggestions next time.
    </p>

    <div class="reason-list">
        <button
            *ngFor="let reason of reasons; trackBy: trackByReason"
            type="button"
            class="reason-btn"
            (click)="onPick(reason.value)">
            <span class="reason-label">{{ reason.label }}</span>
            <i class="ph-bold ph-caret-right reason-caret icon-muted" aria-hidden="true"></i>
        </button>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <flex-spacer></flex-spacer>
    <button
        mat-flat-button
        type="button"
        color="accent"
        [disableRipple]="true"
        (click)="onCancel()">
        Cancel
    </button>
</mat-dialog-actions>
